// Recently Viewed Products Service

const RECENTLY_VIEWED_KEY = "gootocart_recently_viewed";
const MAX_ITEMS = 10;

export const getRecentlyViewed = () => {
  try {
    const data = localStorage.getItem(RECENTLY_VIEWED_KEY);
    if (!data) return [];
    const parsed = JSON.parse(data);
    if (!Array.isArray(parsed)) return [];
    // Sanitize and filter out corrupted entries missing a valid categorySlug
    return parsed.filter(
      (item) =>
        item &&
        item.id &&
        item.slug &&
        item.categorySlug &&
        item.categorySlug !== "undefined"
    );
  } catch (e) {
    return [];
  }
};

export const addRecentlyViewed = (product) => {
  if (!product || !product.id) return;
  try {
    const list = getRecentlyViewed();
    // Remove if already exists to push to front
    const filtered = list.filter((item) => String(item.id) !== String(product.id));

    const categorySlug =
      product.categorySlug && product.categorySlug !== "undefined"
        ? product.categorySlug
        : product.category?.slug;

    const categoryName =
      product.categoryName ||
      product.category?.name ||
      "";

    // Do not save items without a valid category slug to prevent 404s
    if (!categorySlug || categorySlug === "undefined") {
      return;
    }

    const updated = [
      {
        id: product.id,
        name: product.name,
        slug: product.slug,
        image: product.product_image?.[0]?.image || product.image,
        categorySlug,
        categoryName,
        price: product.productprices?.seeling_price || product.sellingPrice || 0,
        viewedAt: new Date().toISOString(),
      },
      ...filtered,
    ].slice(0, MAX_ITEMS);

    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(updated));
    window.dispatchEvent(new Event("recentlyViewedUpdated"));
  } catch (e) {
    // ignore
  }
};

export const retainVisibleRecentlyViewed = (visibleIds) => {
  const allowed = new Set((visibleIds || []).map((id) => String(id)));
  const list = getRecentlyViewed();
  const next = list.filter((item) => allowed.has(String(item.id)));
  if (next.length !== list.length) {
    localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(next));
    window.dispatchEvent(new Event("recentlyViewedUpdated"));
  }
  return next;
};

export const clearRecentlyViewed = () => {
  localStorage.removeItem(RECENTLY_VIEWED_KEY);
  window.dispatchEvent(new Event("recentlyViewedUpdated"));
};
